import { ERROR_MESSAGE } from "../constants/components";

export const StringUtils = {
  isValidEmail: (value: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  },

  // Single source of truth for the password policy, mirroring the server-side
  // PasswordPolicyAttribute (>=8 chars, 3-of-4 character classes, can't contain
  // the account name). Returns an error message, or '' when the password is valid.
  validatePassword: (password: string, email?: string) => {
    if (typeof password !== "string") {
      return "Invalid password format";
    }
    if (password.length < 8) {
      return "Password must be at least 8 characters long.";
    }
    let conditionCount = 0;
    if (/[A-Z]/.test(password)) conditionCount++; // Uppercase
    if (/[a-z]/.test(password)) conditionCount++; // Lowercase
    if (/\d/.test(password)) conditionCount++; // Numeric
    if (/[^\w\d\s]/.test(password)) conditionCount++; // Special characters

    if (conditionCount < 3) {
      return "Password must meet three of the four conditions: Uppercase, Lowercase, Numeric, Special characters.";
    }
    if (email && password.toLowerCase().includes(email.split("@")[0].toLowerCase())) {
      return "Password cannot contain all or part of the user's account name.";
    }
    return "";
  },

  escapeHtml: (value: any) => {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  },

  toPascalCase: (value: string) => {
    return `${value}`
      .replace(new RegExp(/[-_]+/, "g"), " ")
      .replace(new RegExp(/[^\w\s]/, "g"), "")
      .replace(
        new RegExp(/\s+(.)(\w*)/, "g"),
        ($1, $2, $3) => `${$2.toUpperCase() + $3}`
      )
      .replace(new RegExp(/\w/), (s) => s.toUpperCase());
  },

  getFileNameFromDisposition: (disposition: any) => {
    if (disposition && disposition.toString().indexOf("attachment") !== -1) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) return matches[1].replace(/['"]/g, "");
    }
    return "";
  },

  toErrorMessage: (error: any = {}) => {
    if (error.status === 401) {
      // Only treat this as a session expiry (and force a reload) when the
      // user already had an active session. A 401 from an unauthenticated
      // endpoint (e.g. login, send-email-otp) is just an invalid
      // credentials/OTP response and should be shown as a normal error.
      if (sessionStorage.getItem("token")) {
        sessionStorage.removeItem("token");
        setTimeout(() => {
          window.location.reload();
        }, 300);
        return "Session Expired";
      }

      const err = error.errors || error;
      const firstKey = Object.keys(err)[0];
      return (
        err["Title"] || err["title"] || err["CategoryId"] || (firstKey && err[firstKey]) || ERROR_MESSAGE
      );
    } else if (error.status === 403) {
      return "You are not authorized to perform this operation";
    }

    const err = error.errors || error;
    if (err) {
      let firstKey = Object.keys(err)[0];
      if (firstKey) {
        return (
          err["Title"] || err["CategoryId"] || err[firstKey] || ERROR_MESSAGE
        );
      }
      return ERROR_MESSAGE;
    }
    return ERROR_MESSAGE;
  },
};
